module.exports = __webpack_public_path__ + "yadokari_creative_4.png?e843218bd6524494a8097ae3ccabaab2";


//////////////////
// WEBPACK FOOTER
// ./static/img/yadokari_creative_4.png
// module id = 211
// module chunks = 0